import * as Sentry from '@sentry/nextjs'

/* La boîte noire de l'atelier (GlitchTip) — sans DSN, rien ne s'active. */
if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0,
    /* Bruit des webviews in-app (constaté le 13/09) : le mouchard de
       performance qu'Instagram injecte dans SA webview Android plante à la
       fermeture de la page (« Java object is gone ») — code d'Instagram,
       pas le nôtre, zéro impact visiteur. On ne le compte pas. */
    // Le mouchard des navigateurs intégrés Instagram/Facebook (Android ET
    // iOS) : postMessage vers leur pont natif qui echoue — jamais notre code.
    /* ChunkLoadError : transitoire, arrive quand un visiteur a une VIEILLE
       page ouverte au moment d'un redéploiement (les fichiers de son ancienne
       version n'existent plus). Zéro bug de code ; on recharge la page tout
       seul (voir ChunkReload) et on ne compte pas l'erreur. */
    ignoreErrors: [
      /Error invoking postMessage/, 'Java object is gone', 'zp_token',
      /ChunkLoadError/, /Loading chunk [\w-]+ failed/, /Loading CSS chunk/,
    ],
  })
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
